import {Segment} from 'platform/components';
import {Box} from 'platform/foundation';

import {VehicleFinancingType} from '@dms/api/vehicle';
import {FINANCIAL_PRODUCT_TYPE_ICONS} from '@dms/features/financial-products';
import i18n from '@dms/i18n';

import {getFinancingTypeLabel} from './utils/getFinancingTypeLabel';

const FINANCING_TYPES: VehicleFinancingType[] = ['STANDARD', 'BALLOON'];

interface FinancingTypeSegmentProps {
  value: VehicleFinancingType;
  isTypeConfigured: (type: VehicleFinancingType) => boolean;
  onChange: (type: VehicleFinancingType) => void;
}

export function FinancingTypeSegment(props: FinancingTypeSegmentProps) {
  return (
    <Box width="fit-content">
      <Segment<VehicleFinancingType>
        label={i18n.t('entity.financing.labels.pageTitle')}
        value={props.value}
        onChange={props.onChange}
        options={FINANCING_TYPES.map((financingType) => ({
          value: financingType,
          label: getFinancingTypeLabel(financingType),
          leftIcon: FINANCIAL_PRODUCT_TYPE_ICONS[financingType],
          leftIconColor: props.value === financingType ? 'general.accent' : 'text.secondary',
          rightIcon: props.isTypeConfigured(financingType) ? 'action/check_circle' : undefined,
          rightIconColor: 'severity.success',
          rightIconLabel: i18n.t('page.vehicle.financingAndLeasing.configured'),
        }))}
        data-testid="financing-type"
      />
    </Box>
  );
}
